import { fetchConToken, fetchSinToken } from "../../helpers/fetch/fetch"
import { datosEmpresaRequest, empresasUsuarioRequest, empresaRequest, listaEmpresasUsuario } from '../../models/empresas/empresas.models';

export async function obtenerEmpresas(){
    try {
        const resp = await fetchConToken("empresas/listaEmpresas", null, 'GET');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function guardarEmpresasUsuario(empresasUsuarioRequest: empresasUsuarioRequest) {
    try {
        const resp = await fetchConToken("empresasUsuario/altaEmpresasUsuario", empresasUsuarioRequest, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function editarEmpresasUsuario(empresasUsuarioRequest: any) {
    try {
        const resp = await fetchConToken("empresasUsuario/editarEmpresas", empresasUsuarioRequest, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function obtenerEstatusEmpresas(idUsuarioElsa: number) {
    try {
        const resp = await fetchConToken(`empresasUsuario/validarExistenciaEmpresas/${idUsuarioElsa}`, null, 'GET');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function obtenerListaEmpresasUsuario(idUsuarioElsa: number) {
    try {
        const resp = await fetchConToken(`empresasUsuario/listaEmpresas/${idUsuarioElsa}`, null, 'GET');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function guardarDatosEmpresa(datosEmpresaRequest: datosEmpresaRequest) {
    try {
        const resp = await fetchConToken("empresasUsuario/altaDatosEmpresa", datosEmpresaRequest, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function registrarEmpresa(empresa:empresaRequest) {
    try {
        const resp = await fetchConToken("empresas/registrarEmpresa", empresa, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function editarDatosEmpresa(idEmpresa: number, empresa:empresaRequest) {
    try {
        const resp = await fetchConToken(`empresas/editarDatosEmpresa/${idEmpresa}`, empresa, 'POST');
        const body = await resp.json();
        return body;
    } catch {
        return { success: false }
    }
}

export async function  obtenerDatosEmpresa(idUsuario: string, idEmpresaUsuario: string) {
    try {
        const url = `empresasUsuario/obtenerDatosEmpresaEncriptado/${encodeURIComponent(idUsuario)}/${encodeURIComponent(idEmpresaUsuario)}`;
        const resp = await fetchSinToken(url, null, 'GET');
        const body = await resp.json();
        return body;
    } catch {
        return {success : false};
    }
}
